import { Icon } from '@toggle/design-system';
import classnames from 'classnames';
import React from 'react';

import styles from './MarketIndicator.module.scss';

interface MarketIndicatorProps {
  className?: string;
  isMarketOpen: boolean;
  liveText: string;
  closeText: string;
}

export const MarketIndicator = ({
  className,
  isMarketOpen,
  liveText,
  closeText,
}: MarketIndicatorProps) => {
  return (
    <div
      data-testid="market-status"
      className={classnames(
        styles.market,
        { [styles.marketOpen]: isMarketOpen },
        className
      )}
    >
      <Icon
        className={classnames(styles.dotIcon, {
          [styles.marketOpen]: isMarketOpen,
        })}
        iconName="Dot"
        size={16}
      />
      {isMarketOpen ? liveText : closeText}
    </div>
  );
};
